
class Globals {

    breakpoints = {
        tablet : 992,
        mobile : 640
    }
    
    baseSizes = {
        height: 900,
        width: 1440
	}
	
	isLoaded = false

	isScrolling = false

    constructor () {

        this.state = {
            isMobile: false,
            isTablet: false,
            window: {
                width: 0,
                height: 0
			},
			isLoaded: false
        }

        this.resize()

    }

    get width () {
        return this.state.window.width
    }

    get height () {
        return this.state.window.height
    }

    get isMobile () {
        return this.state.isMobile
    }

    get isTablet () {
        return this.state.isTablet
    }

    set width (val) {
        this.state.window.width = val
    }

    set height (val) {
        this.state.window.height = val
    }

    set isMobile (val) {
        this.state.isMobile = val < this.breakpoints.mobile ? true : false
    }

    set isTablet (val) {
        this.state.isTablet = val < this.breakpoints.tablet ? true : false
    }

    resize () {

        const w = window.innerWidth
        const h = window.innerHeight

        this.isMobile = w 
        this.isTablet = w
        this.width = w
        this.height = h

    }

    responsiveHeight (h) {
        return Math.floor(h * window.innerHeight / this.baseSizes.height)
    }

    responsiveWidth (w) {
        return Math.floor(w * window.innerWidth / this.baseSizes.width)
    }


}

export default new Globals()


// WEBPACK FOOTER //
// ./src/utils/Globals.js